class BogaQuoteSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.slides = this.querySelectorAll('.quote-slider__pullquote-wrap');
    this.currentIndex = -1;
    this.count = 0;
    this.colourIndex = 0;
    this.updateSelection();
    setInterval(() => {
      this.updateSelection();
    }, 9000);
  }

  updateSelection() {
    const newIndex = this.currentIndex + 1 < this.slides.length ? this.currentIndex + 1 : 0;
    this.colourIndex = this.colourIndex === 3 ? 0 : this.colourIndex + 1;
    this.count++;
    this.setAttribute('data-index', this.colourIndex);
    this.style.setProperty('--quote-slider-rotation', `${this.count * 90}deg`);
    this.slides.forEach((slide, index) => {
      const isSelected = index === newIndex;
      slide.setAttribute('aria-active', isSelected ? 'true' : 'false');
      slide.setAttribute('tabindex', isSelected ? '0' : '-1');
    });
    this.currentIndex = newIndex;
  }
}

window.customElements.define('boga-quote-slider', BogaQuoteSlider);
